import React from 'react'
import PropTypes from 'prop-types'

import { DropdownArrow, SelectContainer } from './styled'

const Select = ({ onChange, children }) => (
  <SelectContainer>
    <select onChange={onChange}>{children}</select>
    <DropdownArrow />
  </SelectContainer>
)

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default Select



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Search/Select.js